import { defineMessages } from 'react-intl'

export default defineMessages({
  workgrid: {
    id: 'Workgrid',
    defaultMessage: 'Workgrid'
  },
  console: {
    id: 'Console',
    defaultMessage: 'Console'
  },
  unknownUser: {
    id: 'unknown',
    defaultMessage: 'Unknown User'
  },
  all: {
    id: 'all',
    defaultMessage: 'All'
  },
  organizationAuditConnectorPage: {
    id: 'OrganizationAuditConnectorPage.Title',
    defaultMessage: 'API Management'
  },
  save: {
    id: 'save',
    defaultMessage: 'Save'
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel'
  },
  add: {
    id: 'Add',
    defaultMessage: 'Add'
  },
  edit: {
    id: 'Edit',
    defaultMessage: 'Edit'
  },
  delete: {
    id: 'Delete',
    defaultMessage: 'Delete'
  },
  ok: {
    id: 'OK',
    defaultMessage: 'OK'
  },
  okay: {
    id: 'Okay',
    defaultMessage: 'Okay'
  },
  audience: {
    id: 'Audience',
    defaultMessage: 'Audience'
  },
  ownedBy: {
    id: 'OwnedBy',
    defaultMessage: 'Owned by'
  },
  update: {
    id: 'update',
    defaultMessage: 'Update'
  }
})
